import { AnalyticsStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { ProgressIndicator } from '@shared-ui/multi-item-progress-indicator';

import { MultiItemStore } from 'stores/multi-item-store';

import { UitkSpacing } from 'uitk-react-spacing';

export type MitHeaderProps = {
  multiItem?: MultiItemStore;
  analytics?: AnalyticsStore;
};

export const MitHeader: React.FunctionComponent<MitHeaderProps> = inject(
  'multiItem',
  'analytics'
)(
  observer(({ multiItem, analytics }) => {
    if (!multiItem?.isPackageShoppingPath()) {
      return null;
    }

    const multiItemSessionId = multiItem.multiItemSessionId;
    const errorCallback = () => {
      analytics?.trackEvent('MIT.PROGRESS.INDICATOR.ERROR', 'RFRR Action Event', analytics.omnitureData, null, true);
    };
    const changeLinkCallBack = (rfrr: string, linkName: string, event: React.UIEvent) => {
      analytics?.trackEvent(rfrr, linkName, analytics.omnitureData, event, true);
    };

    return (
      <ErrorBoundary label="progress-indicator">
        <UitkSpacing padding={{ small: { block: 'three' }, medium: { blockstart: 'one' }, large: { blockstart: 'three' } }}>
          <div>
            <ProgressIndicator
              inputs={{ multiItemSessionId }}
              showLoadingState={true}
              changeLinkClickCallback={changeLinkCallBack}
              errorCallback={errorCallback}
            />
          </div>
        </UitkSpacing>
      </ErrorBoundary>
    );
  })
);

MitHeader.displayName = 'MitHeader';
